var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproveMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "task_alt_FILL1_wght400_GRAD0_opsz48",
    d: "M14,24a9.738,9.738,0,0,1-3.9-.788A9.984,9.984,0,0,1,4.788,17.9a10.051,10.051,0,0,1,0-7.8A9.984,9.984,0,0,1,10.1,4.788a10.09,10.09,0,0,1,6.887-.338A10.344,10.344,0,0,1,19.6,5.7L18.075,7.225A8.6,8.6,0,0,0,16.15,6.4,7.615,7.615,0,0,0,14,6.1,7.613,7.613,0,0,0,8.413,8.413,7.613,7.613,0,0,0,6.1,14a7.613,7.613,0,0,0,2.313,5.587A7.613,7.613,0,0,0,14,21.9a7.613,7.613,0,0,0,5.587-2.312A7.613,7.613,0,0,0,21.9,14q0-.425-.038-.812a7.636,7.636,0,0,0-.112-.762l1.7-1.7a9.457,9.457,0,0,1,.413,1.587A10.1,10.1,0,0,1,24,14a9.738,9.738,0,0,1-.788,3.9A9.984,9.984,0,0,1,17.9,23.212,9.738,9.738,0,0,1,14,24Zm-1.375-5.425-4.275-4.3L9.825,12.8l2.825,2.825L22.525,5.75,24,7.2Z",
    transform: "translate(-4 -4)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveMark);
export default __webpack_public_path__ + "static/media/approveMark.27d68593bbb0362c20164a3fe4c48d0b.svg";
export { ForwardRef as ReactComponent };